import { InfoText } from "@/components/info-text/src";
import { QuestionComponent as QuestionComponentType } from "@/templates/agile-hub/types";

export type QuestionComponentProps = Omit<QuestionComponentType, "__typename">;
export const QuestionComponent = (data: QuestionComponentProps) => (
    <InfoText
        text={data.answer as string}
        type="html"
        headingText={data.questionTitle as string}
    />
);
